import React, { useState } from 'react'
import '../App.css'
import AddDriver from './AddDriver'
import AddVehicle from './AddVehicle'

function AddForms(props) {
  const [addType, setAddType] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const togglePopupType = (e) => {
    setIsOpen(!isOpen)
    let type = e.target.value
    setAddType(type)
  }
  const togglePopup = (e) => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='AddTypes'>
      {addType === '' ? (
        <span>
          <button id='gradient_Button' value='Lisää kuljettaja' onClick={togglePopupType}>
            Lisää kuljettaja
          </button>
          <button id='gradient_Button' value='Lisää ajoneuvo' onClick={togglePopupType}>
            Lisää auto
          </button>
        </span>
      ) : (
        <span>
          {isOpen && addType === 'Lisää kuljettaja' ? (
            <AddDriver dispatch={props.dispatch} handleClose={togglePopup} />
          ) : isOpen && addType === 'Lisää ajoneuvo' ? (
            <AddVehicle dispatch={props.dispatch} handleClose={togglePopup} priorityGroups={props.priorityGroups} />
          ) : (
            <span>
              <button id='gradient_Button' value='Lisää kuljettaja' onClick={togglePopupType}>
                Lisää kuljettaja
              </button>
              <button id='gradient_Button' value='Lisää ajoneuvo' onClick={togglePopupType}>
                Lisää auto
              </button>
            </span>
          )}
        </span>
      )}
    </div>
  )
}

export default AddForms
